// extracted by mini-css-extract-plugin
export var container = "infoImageCard-module--container--91ad5";
export var info = "infoImageCard-module--info--d283b";
export var logo = "infoImageCard-module--logo--c954e";
export var subcontainer = "infoImageCard-module--subcontainer--87314";